export enum ObjectType {
  LOOP = 'LOOP',
  ONESHOT = 'ONESHOT',
  PACK = 'PACK'
};